import React from 'react';

import { DigitalSubmissionRedirector } from '../components/DigitalSubmissionRedirector/DigitalSubmissionRedirector';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export type DigitalSubmissionsPageProps = {
  name?: string;
};

export const DigitalSubmissionsPage = ({
  name = 'DIGITAL_SUBMISSION_PAGE',
}: DigitalSubmissionsPageProps) => {
  useDocumentTitle('AxiomLaw - Submissions');
  return (
    <div data-test={name}>
      <DigitalSubmissionRedirector />
    </div>
  );
};
